import { render, staticRenderFns } from "./ViewOccurrence.vue?vue&type=template&id=5293c8f3"
import script from "./ViewOccurrence.vue?vue&type=script&lang=ts"
export * from "./ViewOccurrence.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports